module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#video",
      toString: function () {
        return this.url;
      }
    }